module.exports = __webpack_public_path__ + "static/Cocina-prod-7368ee16dead59be9baf600aed85bf04.png";